import React from "react";
import { NavBar } from "antd-mobile";

import "./style.scss";

function CustomNavBar(props) {
  return (
    <NavBar className="agent-mobile-navBar" {...props}>
      {props.children}
    </NavBar>
  );
}

export default CustomNavBar;
